@file:OptIn(InternalResourceApi::class)

package mifos_mobile.feature.accounts.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/mifos_mobile.feature.accounts.generated.resources/"

internal val Res.string.feature_account_title: StringResource by lazy {
      StringResource("string:feature_account_title", "feature_account_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 41),
      ))
    }

internal val Res.string.feature_accounts_filter_status: StringResource by lazy {
      StringResource("string:feature_accounts_filter_status", "feature_accounts_filter_status", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 52, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52, 46),
      ))
    }

internal val Res.string.feature_accounts_filter_type: StringResource by lazy {
      StringResource("string:feature_accounts_filter_type", "feature_accounts_filter_type", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 99, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99, 44),
      ))
    }

internal val Res.string.feature_duration: StringResource by lazy {
      StringResource("string:feature_duration", "feature_duration", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 144, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144, 36),
      ))
    }

internal val Res.string.feature_filters_count: StringResource by lazy {
      StringResource("string:feature_filters_count", "feature_filters_count", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 181, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181, 49),
      ))
    }

internal val Res.string.feature_generic_error_server: StringResource by lazy {
      StringResource("string:feature_generic_error_server", "feature_generic_error_server", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 235, 156),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231, 136),
      ))
    }

internal val Res.string.feature_loan_account_filter_active: StringResource by lazy {
      StringResource("string:feature_loan_account_filter_active", "feature_loan_account_filter_active", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 392, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 368, 50),
      ))
    }

internal val Res.string.feature_loan_account_filter_approval_pending: StringResource by lazy {
      StringResource("string:feature_loan_account_filter_approval_pending", "feature_loan_account_filter_approval_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 443, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 419, 76),
      ))
    }

internal val Res.string.feature_loan_account_filter_bronze: StringResource by lazy {
      StringResource("string:feature_loan_account_filter_bronze", "feature_loan_account_filter_bronze", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 528, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 496, 50),
      ))
    }

internal val Res.string.feature_loan_account_filter_closed: StringResource by lazy {
      StringResource("string:feature_loan_account_filter_closed", "feature_loan_account_filter_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 579, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 547, 50),
      ))
    }

internal val Res.string.feature_loan_account_filter_disburse: StringResource by lazy {
      StringResource("string:feature_loan_account_filter_disburse", "feature_loan_account_filter_disburse", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 634, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 598, 72),
      ))
    }

internal val Res.string.feature_loan_account_filter_in_arrears: StringResource by lazy {
      StringResource("string:feature_loan_account_filter_in_arrears", "feature_loan_account_filter_in_arrears", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 707, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 671, 62),
      ))
    }

internal val Res.string.feature_loan_account_filter_matured: StringResource by lazy {
      StringResource("string:feature_loan_account_filter_matured", "feature_loan_account_filter_matured", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 766, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 734, 55),
      ))
    }

internal val Res.string.feature_loan_account_filter_overpaid: StringResource by lazy {
      StringResource("string:feature_loan_account_filter_overpaid", "feature_loan_account_filter_overpaid", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 822, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 790, 56),
      ))
    }

internal val Res.string.feature_loan_account_filter_personal: StringResource by lazy {
      StringResource("string:feature_loan_account_filter_personal", "feature_loan_account_filter_personal", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 883, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 847, 56),
      ))
    }

internal val Res.string.feature_loan_account_filter_rejected: StringResource by lazy {
      StringResource("string:feature_loan_account_filter_rejected", "feature_loan_account_filter_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 940, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 904, 56),
      ))
    }

internal val Res.string.feature_loan_account_filter_withdrawn: StringResource by lazy {
      StringResource("string:feature_loan_account_filter_withdrawn", "feature_loan_account_filter_withdrawn", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 997, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 961, 57),
      ))
    }

internal val Res.string.feature_loan_account_title: StringResource by lazy {
      StringResource("string:feature_loan_account_title", "feature_loan_account_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1055, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1019, 54),
      ))
    }

internal val Res.string.feature_no__filtered_transactions_found: StringResource by lazy {
      StringResource("string:feature_no__filtered_transactions_found", "feature_no__filtered_transactions_found", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1118, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1074, 103),
      ))
    }

internal val Res.string.feature_no_transactions_found: StringResource by lazy {
      StringResource("string:feature_no_transactions_found", "feature_no_transactions_found", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1250, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1178, 65),
      ))
    }

internal val Res.string.feature_saving_account_title: StringResource by lazy {
      StringResource("string:feature_saving_account_title", "feature_saving_account_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1312, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1244, 56),
      ))
    }

internal val Res.string.feature_savings_apply: StringResource by lazy {
      StringResource("string:feature_savings_apply", "feature_savings_apply", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1373, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1301, 37),
      ))
    }

internal val Res.string.feature_savings_filter: StringResource by lazy {
      StringResource("string:feature_savings_filter", "feature_savings_filter", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1978, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1886, 42),
      ))
    }

internal val Res.string.feature_savings_filter_active_account: StringResource by lazy {
      StringResource("string:feature_savings_filter_active_account", "feature_savings_filter_active_account", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1415, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1339, 53),
      ))
    }

internal val Res.string.feature_savings_filter_approved_account: StringResource by lazy {
      StringResource("string:feature_savings_filter_approved_account", "feature_savings_filter_approved_account", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1469, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1393, 59),
      ))
    }

internal val Res.string.feature_savings_filter_bank_account: StringResource by lazy {
      StringResource("string:feature_savings_filter_bank_account", "feature_savings_filter_bank_account", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1529, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1453, 59),
      ))
    }

internal val Res.string.feature_savings_filter_closed_account: StringResource by lazy {
      StringResource("string:feature_savings_filter_closed_account", "feature_savings_filter_closed_account", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1593, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1513, 53),
      ))
    }

internal val Res.string.feature_savings_filter_group_account: StringResource by lazy {
      StringResource("string:feature_savings_filter_group_account", "feature_savings_filter_group_account", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1651, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1567, 64),
      ))
    }

internal val Res.string.feature_savings_filter_matured_account: StringResource by lazy {
      StringResource("string:feature_savings_filter_matured_account", "feature_savings_filter_matured_account", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1716, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1632, 58),
      ))
    }

internal val Res.string.feature_savings_filter_nb_account: StringResource by lazy {
      StringResource("string:feature_savings_filter_nb_account", "feature_savings_filter_nb_account", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1775, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1691, 57),
      ))
    }

internal val Res.string.feature_savings_filter_pending_account: StringResource by lazy {
      StringResource("string:feature_savings_filter_pending_account", "feature_savings_filter_pending_account", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1829, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1749, 70),
      ))
    }

internal val Res.string.feature_savings_filter_wallet_account: StringResource by lazy {
      StringResource("string:feature_savings_filter_wallet_account", "feature_savings_filter_wallet_account", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1908, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1820, 65),
      ))
    }

internal val Res.string.feature_savings_reset: StringResource by lazy {
      StringResource("string:feature_savings_reset", "feature_savings_reset", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2021, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1929, 37),
      ))
    }

internal val Res.string.feature_share_account_title: StringResource by lazy {
      StringResource("string:feature_share_account_title", "feature_share_account_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2063, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1967, 55),
      ))
    }

internal val Res.string.feature_transaction_detail_account_ref: StringResource by lazy {
      StringResource("string:feature_transaction_detail_account_ref", "feature_transaction_detail_account_ref", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2127, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2023, 62),
      ))
    }

internal val Res.string.feature_transaction_detail_balance: StringResource by lazy {
      StringResource("string:feature_transaction_detail_balance", "feature_transaction_detail_balance", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2202, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2086, 66),
      ))
    }

internal val Res.string.feature_transaction_detail_breakdown: StringResource by lazy {
      StringResource("string:feature_transaction_detail_breakdown", "feature_transaction_detail_breakdown", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2269, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2153, 56),
      ))
    }

internal val Res.string.feature_transaction_detail_date: StringResource by lazy {
      StringResource("string:feature_transaction_detail_date", "feature_transaction_detail_date", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2326, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2210, 47),
      ))
    }

internal val Res.string.feature_transaction_detail_default_type: StringResource by lazy {
      StringResource("string:feature_transaction_detail_default_type", "feature_transaction_detail_default_type", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2374, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2258, 63),
      ))
    }

internal val Res.string.feature_transaction_detail_external_id: StringResource by lazy {
      StringResource("string:feature_transaction_detail_external_id", "feature_transaction_detail_external_id", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2438, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2322, 62),
      ))
    }

internal val Res.string.feature_transaction_detail_fees: StringResource by lazy {
      StringResource("string:feature_transaction_detail_fees", "feature_transaction_detail_fees", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2501, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2385, 47),
      ))
    }

internal val Res.string.feature_transaction_detail_id: StringResource by lazy {
      StringResource("string:feature_transaction_detail_id", "feature_transaction_detail_id", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2557, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2433, 57),
      ))
    }

internal val Res.string.feature_transaction_detail_interest: StringResource by lazy {
      StringResource("string:feature_transaction_detail_interest", "feature_transaction_detail_interest", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2615, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2491, 55),
      ))
    }

internal val Res.string.feature_transaction_detail_payment_method: StringResource by lazy {
      StringResource("string:feature_transaction_detail_payment_method", "feature_transaction_detail_payment_method", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2671, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2547, 69),
      ))
    }

internal val Res.string.feature_transaction_detail_penalties: StringResource by lazy {
      StringResource("string:feature_transaction_detail_penalties", "feature_transaction_detail_penalties", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2741, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2617, 56),
      ))
    }

internal val Res.string.feature_transaction_detail_principal: StringResource by lazy {
      StringResource("string:feature_transaction_detail_principal", "feature_transaction_detail_principal", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2806, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2674, 56),
      ))
    }

internal val Res.string.feature_transaction_detail_receipt: StringResource by lazy {
      StringResource("string:feature_transaction_detail_receipt", "feature_transaction_detail_receipt", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2863, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2731, 54),
      ))
    }

internal val Res.string.feature_transaction_detail_status: StringResource by lazy {
      StringResource("string:feature_transaction_detail_status", "feature_transaction_detail_status", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3055, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2911, 49),
      ))
    }

internal val Res.string.feature_transaction_detail_status_reversed: StringResource by lazy {
      StringResource("string:feature_transaction_detail_status_reversed", "feature_transaction_detail_status_reversed", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2930, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2786, 62),
      ))
    }

internal val Res.string.feature_transaction_detail_status_success: StringResource by lazy {
      StringResource("string:feature_transaction_detail_status_success", "feature_transaction_detail_status_success", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2993, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2849, 61),
      ))
    }

internal val Res.string.feature_transaction_detail_type: StringResource by lazy {
      StringResource("string:feature_transaction_detail_type", "feature_transaction_detail_type", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3105, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2961, 47),
      ))
    }

internal val Res.string.feature_transaction_details: StringResource by lazy {
      StringResource("string:feature_transaction_details", "feature_transaction_details", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3153, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3009, 63),
      ))
    }

internal val Res.string.feature_transaction_download_icon_description: StringResource by lazy {
      StringResource("string:feature_transaction_download_icon_description", "feature_transaction_download_icon_description", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3225, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3073, 73),
      ))
    }

internal val Res.string.feature_transaction_filter: StringResource by lazy {
      StringResource("string:feature_transaction_filter", "feature_transaction_filter", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3829, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3641, 42),
      ))
    }

internal val Res.string.feature_transaction_filter_credit: StringResource by lazy {
      StringResource("string:feature_transaction_filter_credit", "feature_transaction_filter_credit", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3303, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3147, 49),
      ))
    }

internal val Res.string.feature_transaction_filter_debit: StringResource by lazy {
      StringResource("string:feature_transaction_filter_debit", "feature_transaction_filter_debit", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3357, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3197, 48),
      ))
    }

internal val Res.string.feature_transaction_filter_icon_description: StringResource by lazy {
      StringResource("string:feature_transaction_filter_icon_description", "feature_transaction_filter_icon_description", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3410, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3246, 67),
      ))
    }

internal val Res.string.feature_transaction_filter_past_1_year: StringResource by lazy {
      StringResource("string:feature_transaction_filter_past_1_year", "feature_transaction_filter_past_1_year", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3482, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3314, 62),
      ))
    }

internal val Res.string.feature_transaction_filter_past_2_years: StringResource by lazy {
      StringResource("string:feature_transaction_filter_past_2_years", "feature_transaction_filter_past_2_years", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3549, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3377, 63),
      ))
    }

internal val Res.string.feature_transaction_filter_past_3_months: StringResource by lazy {
      StringResource("string:feature_transaction_filter_past_3_months", "feature_transaction_filter_past_3_months", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3621, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3441, 68),
      ))
    }

internal val Res.string.feature_transaction_filter_past_6_months: StringResource by lazy {
      StringResource("string:feature_transaction_filter_past_6_months", "feature_transaction_filter_past_6_months", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3694, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3510, 68),
      ))
    }

internal val Res.string.feature_transaction_filter_past_month: StringResource by lazy {
      StringResource("string:feature_transaction_filter_past_month", "feature_transaction_filter_past_month", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3767, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3579, 61),
      ))
    }

internal val Res.string.feature_transaction_statement: StringResource by lazy {
      StringResource("string:feature_transaction_statement", "feature_transaction_statement", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3872, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3684, 49),
      ))
    }

internal val Res.string.feature_transaction_transaction_history: StringResource by lazy {
      StringResource("string:feature_transaction_transaction_history", "feature_transaction_transaction_history", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3934, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3734, 75),
      ))
    }

internal val Res.string.feature_transaction_type: StringResource by lazy {
      StringResource("string:feature_transaction_type", "feature_transaction_type", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4018, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3810, 56),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_account_title", Res.string.feature_account_title)
  map.put("feature_accounts_filter_status", Res.string.feature_accounts_filter_status)
  map.put("feature_accounts_filter_type", Res.string.feature_accounts_filter_type)
  map.put("feature_duration", Res.string.feature_duration)
  map.put("feature_filters_count", Res.string.feature_filters_count)
  map.put("feature_generic_error_server", Res.string.feature_generic_error_server)
  map.put("feature_loan_account_filter_active", Res.string.feature_loan_account_filter_active)
  map.put("feature_loan_account_filter_approval_pending", Res.string.feature_loan_account_filter_approval_pending)
  map.put("feature_loan_account_filter_bronze", Res.string.feature_loan_account_filter_bronze)
  map.put("feature_loan_account_filter_closed", Res.string.feature_loan_account_filter_closed)
  map.put("feature_loan_account_filter_disburse", Res.string.feature_loan_account_filter_disburse)
  map.put("feature_loan_account_filter_in_arrears", Res.string.feature_loan_account_filter_in_arrears)
  map.put("feature_loan_account_filter_matured", Res.string.feature_loan_account_filter_matured)
  map.put("feature_loan_account_filter_overpaid", Res.string.feature_loan_account_filter_overpaid)
  map.put("feature_loan_account_filter_personal", Res.string.feature_loan_account_filter_personal)
  map.put("feature_loan_account_filter_rejected", Res.string.feature_loan_account_filter_rejected)
  map.put("feature_loan_account_filter_withdrawn", Res.string.feature_loan_account_filter_withdrawn)
  map.put("feature_loan_account_title", Res.string.feature_loan_account_title)
  map.put("feature_no__filtered_transactions_found", Res.string.feature_no__filtered_transactions_found)
  map.put("feature_no_transactions_found", Res.string.feature_no_transactions_found)
  map.put("feature_saving_account_title", Res.string.feature_saving_account_title)
  map.put("feature_savings_apply", Res.string.feature_savings_apply)
  map.put("feature_savings_filter", Res.string.feature_savings_filter)
  map.put("feature_savings_filter_active_account", Res.string.feature_savings_filter_active_account)
  map.put("feature_savings_filter_approved_account", Res.string.feature_savings_filter_approved_account)
  map.put("feature_savings_filter_bank_account", Res.string.feature_savings_filter_bank_account)
  map.put("feature_savings_filter_closed_account", Res.string.feature_savings_filter_closed_account)
  map.put("feature_savings_filter_group_account", Res.string.feature_savings_filter_group_account)
  map.put("feature_savings_filter_matured_account", Res.string.feature_savings_filter_matured_account)
  map.put("feature_savings_filter_nb_account", Res.string.feature_savings_filter_nb_account)
  map.put("feature_savings_filter_pending_account", Res.string.feature_savings_filter_pending_account)
  map.put("feature_savings_filter_wallet_account", Res.string.feature_savings_filter_wallet_account)
  map.put("feature_savings_reset", Res.string.feature_savings_reset)
  map.put("feature_share_account_title", Res.string.feature_share_account_title)
  map.put("feature_transaction_detail_account_ref", Res.string.feature_transaction_detail_account_ref)
  map.put("feature_transaction_detail_balance", Res.string.feature_transaction_detail_balance)
  map.put("feature_transaction_detail_breakdown", Res.string.feature_transaction_detail_breakdown)
  map.put("feature_transaction_detail_date", Res.string.feature_transaction_detail_date)
  map.put("feature_transaction_detail_default_type", Res.string.feature_transaction_detail_default_type)
  map.put("feature_transaction_detail_external_id", Res.string.feature_transaction_detail_external_id)
  map.put("feature_transaction_detail_fees", Res.string.feature_transaction_detail_fees)
  map.put("feature_transaction_detail_id", Res.string.feature_transaction_detail_id)
  map.put("feature_transaction_detail_interest", Res.string.feature_transaction_detail_interest)
  map.put("feature_transaction_detail_payment_method", Res.string.feature_transaction_detail_payment_method)
  map.put("feature_transaction_detail_penalties", Res.string.feature_transaction_detail_penalties)
  map.put("feature_transaction_detail_principal", Res.string.feature_transaction_detail_principal)
  map.put("feature_transaction_detail_receipt", Res.string.feature_transaction_detail_receipt)
  map.put("feature_transaction_detail_status", Res.string.feature_transaction_detail_status)
  map.put("feature_transaction_detail_status_reversed", Res.string.feature_transaction_detail_status_reversed)
  map.put("feature_transaction_detail_status_success", Res.string.feature_transaction_detail_status_success)
  map.put("feature_transaction_detail_type", Res.string.feature_transaction_detail_type)
  map.put("feature_transaction_details", Res.string.feature_transaction_details)
  map.put("feature_transaction_download_icon_description", Res.string.feature_transaction_download_icon_description)
  map.put("feature_transaction_filter", Res.string.feature_transaction_filter)
  map.put("feature_transaction_filter_credit", Res.string.feature_transaction_filter_credit)
  map.put("feature_transaction_filter_debit", Res.string.feature_transaction_filter_debit)
  map.put("feature_transaction_filter_icon_description", Res.string.feature_transaction_filter_icon_description)
  map.put("feature_transaction_filter_past_1_year", Res.string.feature_transaction_filter_past_1_year)
  map.put("feature_transaction_filter_past_2_years", Res.string.feature_transaction_filter_past_2_years)
  map.put("feature_transaction_filter_past_3_months", Res.string.feature_transaction_filter_past_3_months)
  map.put("feature_transaction_filter_past_6_months", Res.string.feature_transaction_filter_past_6_months)
  map.put("feature_transaction_filter_past_month", Res.string.feature_transaction_filter_past_month)
  map.put("feature_transaction_statement", Res.string.feature_transaction_statement)
  map.put("feature_transaction_transaction_history", Res.string.feature_transaction_transaction_history)
  map.put("feature_transaction_type", Res.string.feature_transaction_type)
}
